import { BaseFilter } from "./base-filter.interface";

export interface FiltroElencoRisorse extends BaseFilter {
  risorsa?: string | null;
  nomeRisorsa?: string | null;
  nomeResponsabile?: string | null;
  codiceUnitaOrganizzativa?: string | null;
  descrizioneUnitaOrganizzativa?: string | null;
  codiceUnitaOrganizzativaPrimoLivello?: string | null;
  descrizioneUnitaOrganizzativaPrimoLivello?: string | null;
  modificato?: boolean | null;
  approvato?: boolean | null;
  nomeDelegante?: string | null;
  nomeApprovatore?: string | null;
  dataApprovazione?: string | null;
}

export const filtroElencoRisorseVuoto: FiltroElencoRisorse = {
  risorsa: null,
  nomeRisorsa: null,
  nomeResponsabile: null,
  codiceUnitaOrganizzativa: null,
  descrizioneUnitaOrganizzativa: null,
  codiceUnitaOrganizzativaPrimoLivello: null,
  descrizioneUnitaOrganizzativaPrimoLivello: null,
  modificato: null,
  approvato: null,
  nomeDelegante: null,
  nomeApprovatore: null,
  dataApprovazione: null,
  pageNumber: 1,
  pageSize: 10,
  orderBy: '',
  flagAsc: true,
  flagExport: false,
};
